import React, { useState, useRef } from "react";
import type { AccentColourType } from "../../../../../../../common-deprecated/types/CommonTypes";
import PopoverTooltip from "../../../../../../../common-deprecated/components/popover/aem/lexus/PopoverTooltip";
import * as Styles from "./styles/AccentColours";

type AccentColourPropType = {
    colour: AccentColourType;
    selectColour: (colour: AccentColourType) => void;
    enabled: boolean;
    isActive: boolean;
};
const AccentColour = (props: AccentColourPropType): JSX.Element => {
    const { colour, enabled, selectColour, isActive } = props;
    const colourRef = useRef<HTMLDivElement>(null);
    const [showTooltip, setShowTooltip] = useState<boolean>(false);

    return (
        <Styles.Colour
            ref={colourRef}
            key={colour.id}
            backgroundColor={
                colour.rgb ? `#${colour.rgb.substr(0, 2) === "0x" ? colour.rgb.substr(2) : colour.rgb}` : "transparent"
            }
            opacity={enabled ? 1 : 0.15}
            onClick={enabled ? () => selectColour(colour) : undefined}
            onMouseEnter={() => colour.name && setShowTooltip(true)}
            onMouseLeave={() => colour.name && setShowTooltip(false)}
            isActive={isActive}
        >
            {isActive && <Styles.ActiveColour />}
            {colour.name && showTooltip && enabled && (
                <PopoverTooltip content={colour.name} iconRef={colourRef} onClose={() => setShowTooltip(false)} small />
            )}
        </Styles.Colour>
    );
};

type AccentColoursType = {
    selectedColour?: AccentColourType | null;
    colours: AccentColourType[];
    selectColour: (colour: AccentColourType) => void;
    enabled: boolean;
};
const AccentColours = (props: AccentColoursType): JSX.Element => {
    const { selectedColour, colours, selectColour, enabled } = props;

    return (
        <Styles.ColoursWrapper>
            {colours.map((colour) => (
                <AccentColour
                    key={colour.id}
                    colour={colour}
                    enabled={enabled}
                    isActive={enabled && !!selectedColour && colour.id === selectedColour.id}
                    selectColour={selectColour}
                />
            ))}
        </Styles.ColoursWrapper>
    );
};

export default AccentColours;
